export const setInvitationSkipped = '@dasboard/setInvitationSkipped';
export const setChartData = '@dasboard/setChartData';
export const setLoading = '@dasboard/setLoading';
export const setIsSplit = '@dasboard/setIsSplit';
export const setShowSharePrice = '@dasboard/setShowSharePrice';
export const setDataType = '@dasboard/setDataType';
export const setTimeRange = '@dasboard/setTimeRange';
export const setIsNumber = '@dasboard/setIsNumber';
export const setIsPercentage = '@dasboard/setIsPercentage';
export const setAllEngagementValue = '@dashboard/setAllEngagementValue';
